import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getProfilePageBanners } from '../../services'
import { ProfilePageBannerQueryKeys } from '@/modules/client-setting/keys'
import { GetProfilePageBannersResponse } from '@/modules/client-setting/type'

export default function useQueryGetProfilePageBanners(
	props?: UseBaseQueryOptions<GetProfilePageBannersResponse>,
) {
	return useQuery({
		queryKey: [ProfilePageBannerQueryKeys.GetProfilePageBanners],
		queryFn: () => getProfilePageBanners(),
		...props,
	})
}
